<template>
  <div
    class="vertical-layout vertical-menu-modern 1-column  navbar-floating footer-static bg-full-screen-image  blank-page blank-page"
    data-open="click"
    data-menu="vertical-menu-modern"
    data-col="1-column"
  >
    <div class="col-xl-7 col-md-9 col-10 d-flex justify-content-center px-0">
      <div class="card bg-authentication rounded-0 mb-0">
        <div class="row m-0">
          <div class="col-lg-6 d-lg-block d-none text-center align-self-center">
            <img src="../../../../assets/images/forgot-password.png" alt="branding logo" />
          </div>
          <div class="col-lg-6 col-12 p-0">
            <div class="card rounded-0 mb-0 px-2 py-1">
              <div class="card-header pb-1">
                <div class="card-title">
                  <h4 class="mb-0">Recover your password</h4>
                </div>
              </div>
              <p class="px-2 mb-0">
                Please enter your email address and we'll send you instructions on how to reset your
                password.
              </p>
              <div class="card-content">
                <div class="card-body">
                  <div action="index.html">
                    <div class="form-label-group">
                      <input
                        type="email"
                        id="inputEmail"
                        class="form-control"
                        placeholder="Email"
                        autocomplete="email"
                        :value="fields.email.value"
                        @input="_updateFieldValue('email', $event.target.value)"
                        @blur="_markAsDirty('email')"
                      />
                      <label for="inputEmail">Email</label>
                    </div>
                    <p class="inputError">
                      {{
                        fields.email.isDirty && !fields.email.isValid
                          ? "Please enter a valid email"
                          : ""
                      }}
                    </p>
                  </div>
                  <div class="float-md-left d-block mb-1">
                    <a
                      href="#"
                      @click="$router.push('/login')"
                      class="btn btn-outline-primary btn-block px-75"
                      >Back to Login</a
                    >
                  </div>
                  <div class="float-md-right d-block mb-1">
                    <a href="#" @click="_sendEmail" class="btn btn-primary btn-block px-75"
                      >Recover Password</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay :value="dialog">
      <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
    </v-overlay>
  </div>
</template>

<script>
  /* eslint-disable */
export default {
  name: "ForgetPasswordPage",
  data() {
    return {
      dialog: false,
      fields: {
        email: {
          value: "",
          isDirty: false,
          isValid: false
        }
      },
      isFormValid: false,
      snackbar: false,
      notification: false,
      generalError: {
        isVisible: false,
        errorText: ""
      }
    };
  },
  computed: {},
  created() {},
  methods: {
    async setUserAndRedirectToDashboard(email) {
      localStorage.setItem("username", email);
      this.$router.push("/pages/senders");
      this.dialog = false;
    },
    _markAsDirty(fieldName) {
      this.fields[fieldName].isDirty = true;
    },
    _updateFieldValue(fieldName, value) {
      this.fields[fieldName].value = value;
      this._validateForm();
    },
    _validateForm() {
      let isFormValid = true;
      Object.keys(this.fields).forEach(fieldName => {
        this.fields[fieldName].isValid = true;
        // Default case is not required
        // eslint-disable-next-line default-case
        switch (fieldName) {
          case "email": {
            const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!emailRegex.test(String(this.fields[fieldName].value).toLowerCase())) {
              this.fields[fieldName].isValid = false;
              isFormValid = false;
            }
            break;
          }
        }
      });
      this.isFormValid = isFormValid;
    },
    _makeAllFieldDirty() {
      Object.keys(this.fields).forEach(fieldName => {
        this.fields[fieldName].isDirty = true;
      });
    },
    async _sendEmail(e) {
      this.generalError = {
        isVisible: false,
        errorText: ""
      };
      e.preventDefault();
      this._makeAllFieldDirty();
      this._validateForm();
      if (this.isFormValid) {
        this.dialog = true;
        const email = this.fields.email.value;
        try {
          // await FirebaseAuthService.sendResetPasswordEmail(email);
          this.dialog = false;
          this.notification = "Reset email sent";
          this.snackbar = true;
          setTimeout(() => {
            this.dialog = false;
            this.notification = "Redirecting to login";
            this.snackbar = true;
            setTimeout(() => {
              this.$router.push("/login");
            }, 3000);
          }, 3000);
        } catch (error) {
          this.dialog = false;
          this.notification = error.message;
          this.snackbar = true;
        }
      }
    }
  }
};
</script>

<style>
@import url("./forgot-password-page.scss");
</style>
